import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AsssignedMembersTab from "./AsssignedMembersTab";
import { fetchAssignedMembersData } from "../../../redux/reducers/apiSlice";
import { selectToken } from "../../auth/auth.selector";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";

const AssignedMembers = ({ sendableQPs }) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  let { loading, assignedMembersData } = useSelector((state) => state.api);

  const [searchString, setSearchString] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const initialDatas = {
    allData: [],
    pageNo: 0,
    pagination: [],
  };
  const [allAssignedMembersData, setAllAssignedMembersData] =
    useState(initialDatas);
  const [selectedKey, setSelectdKey] = useState("addon_pt");

  const searchQueryParam = searchString ? `&search=${searchString}` : "";
  const typeParam = selectedKey ? `&type=${selectedKey}` : "";
  sendableQPs += typeParam;

  const onClickSearch = (e) => {
    e.preventDefault();
    setIsSearch(true);

    dispatch(
      fetchAssignedMembersData({
        queryParameters: sendableQPs + searchQueryParam,
        token: token,
      })
    );
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSearch(e);
    }
  };

  useEffect(() => {
    if (sendableQPs) {
      dispatch(
        fetchAssignedMembersData({
          queryParameters: sendableQPs,
          token: token,
        })
      );
    }
  }, [sendableQPs]);

  useEffect(() => {
    if (assignedMembersData?.status && assignedMembersData?.data?.length > 0) {
      setAllAssignedMembersData({
        ...allAssignedMembersData,
        allData: assignedMembersData.data,
        pagination: assignedMembersData?.pagination,
      });
    } else {
      setAllAssignedMembersData(initialDatas);
    }
  }, [assignedMembersData]);

  useEffect(() => {
    if (isSearch && searchString?.length === 0) {
      setIsSearch(false);

      if (sendableQPs) {
        dispatch(
          fetchAssignedMembersData({
            queryParameters: sendableQPs,
            token: token,
          })
        );
      }
    }
  }, [searchString]);

  return (
    <div className="allPtMembersContainer allPtPlansContainer">
      <div className="headerSearchbar">
        <h2 className="header">Assigned Member</h2>
      </div>

      <div
        className="ptMembersTabAndButtons"
        style={{ flexDirection: "column-reverse" }}
      >
        <AsssignedMembersTab
          setSelectdKey={setSelectdKey}
          allAssignedMembersData={allAssignedMembersData}
          setAllAssignedMembersData={setAllAssignedMembersData}
          loading={loading}
        />

        <div
          className="inputCommonWrapper searchbar searchBarContainer"
          style={{ width: "100%" }}
        >
          <button
            type="button"
            className="button"
            onClick={(e) => onClickSearch(e)}
          >
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                search
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              </>
            )}
          </button>
          <input
            type="search"
            placeholder="Search by name ,number or email"
            value={searchString}
            onChange={(e) => {
              setSearchString(e.target.value);
            }}
            onKeyDown={handleKeyPress}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignedMembers;
